import { useSearchParams } from '@remix-run/react';
import { useState, useCallback, useEffect } from 'react';
import { LoginDialog } from '~/components/chat/LoginDialog.client';
import { Button } from '~/components/ui/Button';
import { INVITE_TOKEN_SEARCH_PARAM } from '~/lib/stores/pricing/config';
import { classNames } from '~/utils/classNames';

interface AuthButtonsProps {
  className?: string;
}

export const AuthButtons = ({ className }: AuthButtonsProps) => {
  const [loginDialogOpen, setLoginDialogOpen] = useState(false);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const shouldOpenDialog = checkAndRemoveGetStartedParam();

    if (shouldOpenDialog) {
      setLoginDialogOpen(true);
    }
  }, []);

  const handleOpenLoginDialog = useCallback(() => {
    setLoginDialogOpen(true);
  }, []);

  const handleCloseLoginDialog = useCallback(() => {
    setLoginDialogOpen(false);
  }, []);

  useEffect(() => {
    const inviteToken = searchParams.get(INVITE_TOKEN_SEARCH_PARAM);

    if (inviteToken) {
      handleOpenLoginDialog();
    }
  }, [searchParams]);

  return (
    <>
      <div className={classNames('items-center gap-3', className)}>
        <Button className="whitespace-nowrap" size="sm" variant="secondary" onClick={handleOpenLoginDialog}>
          Sign in
        </Button>

        <Button className="whitespace-nowrap min-h-6" size="sm" variant="primary" onClick={handleOpenLoginDialog}>
          Get started
        </Button>
      </div>

      <LoginDialog open={loginDialogOpen} onClose={handleCloseLoginDialog} onLoginSuccess={handleCloseLoginDialog} />
    </>
  );
};

function checkAndRemoveGetStartedParam(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const url = new URL(window.location.href);
  const hasGetStarted = url.searchParams.has('get_started');

  if (hasGetStarted) {
    url.searchParams.delete('get_started');
    window.history.replaceState(null, '', url.pathname + url.search);
  }

  return hasGetStarted;
}
